export function healthColor(score) {
  if (score >= 85) return "text-emerald-600";
  if (score >= 65) return "text-amber-600";
  return "text-red-600";
}

export function formatINR(n) {
  if (n === null || n === undefined) return "—";
  return "₹" + Number(n).toLocaleString("en-IN");
}

export const PLATFORMS = ["amazon", "flipkart", "meesho", "shopify"];
export const PLATFORM_LABELS = { amazon: "Amazon", flipkart: "Flipkart", meesho: "Meesho", shopify: "Shopify" };
